export const PREFIX = '$entrance'; // 前缀

export const LOCAL_LANG = `${PREFIX}_lang`; // 本地存储语言的key

export const CAPTCHA_CODE = '40011';
export const TOKEN_INVALID_CODE = '280001';
export const MAIL_AUTHORIZE_EXPIRE_CODE = '500017'; // 邮件授权过期的code

export const UTM_RCODE_MAP = {
  thirdPartClient: 'utm_source',
  utmCampaign: 'utm_campaign',
  utmMedium: 'utm_medium',
  referralCode: 'rcode',
};

export const FORBIDDEN_COUNTRIES_FOR_USE = [
  {
    code: 'CN',
    mobileCode: '86',
    aliasName: '其他', // 被屏蔽的国家，界面显示的别名
    aliasNameEN: 'Other',
  },
];

export const SIGNIN_ACCOUNT_TRACKING_KEY = `${PREFIX}_login_accout_track_key`;

export const DEFAULT_TRACK_SRC = 'mainSet';
